import {
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardHeaderTitle,
  IconListItem,
  Text,
  UnorderedList,
} from "@prismicio/editor-ui"

import { getRepositoryName } from "../../app/routing"
import { Link } from "../../app/routing/Link"

const hubspotUserRolesLeadCollectionFormUrl = `https://share.hsforms.com/1UT6cP6SVRyibuvRKUOz4aw37uwq?repository_name=${getRepositoryName()}`

export function TeamSpacesDialogUserTab() {
  return (
    <Box
      alignItems="center"
      justifyContent="center"
      minHeight="100%"
      overflow="hidden"
      flexShrink={0}
    >
      <Card
        color="purple2"
        variant="outlined"
        paddingBlock={32}
        paddingLeft={32}
        paddingRight={16}
        gap={8}
        sx={{
          width: 356,
        }}
      >
        <CardHeader>
          <CardHeaderTitle variant="h3" sx={{ flexGrow: 0 }}>
            Custom Roles
          </CardHeaderTitle>
          <Badge color="purple" title="Coming soon" />
        </CardHeader>
        <CardContent gap={16}>
          <Text variant="normal" color="grey12">
            Set access rights per Space
          </Text>

          <UnorderedList>
            <IconListItem>
              Have greater control over who can edit content
            </IconListItem>

            <IconListItem>
              Ensure contributors are focused on content related to their role
            </IconListItem>

            <IconListItem>
              Expand power to update pages with scoped ownership and more safety
            </IconListItem>
          </UnorderedList>

          <Button color="purple" size="large" sx={{ marginRight: 16 }} asChild>
            <Link to={hubspotUserRolesLeadCollectionFormUrl} target="_blank">
              Contact sales
            </Link>
          </Button>

          <Text variant="small" color="grey11" sx={{ marginRight: 16 }}>
            This feature is for Enterprise customers. Get in touch with our
            Sales Team to know more.
          </Text>
        </CardContent>
      </Card>
    </Box>
  )
}
